import { InputHTMLAttributes, useRef } from 'react'

import crossIcon from 'assets/images/explore-learnings/modal-cross.svg'

interface FormInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string
  labelSuffix?: string
  error?: string
  onClear?: () => void
}

export const FormInput = ({
  label,
  labelSuffix,
  error,
  className,
  onClear,
  onChange,
  value,
  ...rest
}: FormInputProps): JSX.Element => {
  const inputRef = useRef<HTMLInputElement>(null)

  const handleClear = (): void => {
    onClear?.()
    inputRef.current?.focus()
  }

  const hasValue = value !== '' && value !== undefined && value !== null

  return (
    <div className="flex-1">
      <label className="block subtitle-m mb-2 text-neutral-80">
        {label}
        {labelSuffix && <span className="normal-case font-normal text-gray-500 ml-1">{labelSuffix}</span>}
      </label>
      <div className="relative flex items-center">
        <input
          ref={inputRef}
          value={value}
          onChange={onChange}
          {...rest}
          className={`w-full border border-solid rounded-lg px-2.5 py-[7px] leading-6 text-sm placeholder-[#6E6E6E] outline-none text-ellipsis overflow-hidden transition
            ${hasValue ? 'pr-8' : ''}
            ${error ? 'border-red-60' : 'border-[#9B9B9B] focus:border-black text-black'}
            ${className ?? ''}`}
        />
        {hasValue && (
          <button
            type="button"
            onClick={handleClear}
            className="absolute right-2.5 flex items-center justify-center text-gray-400 hover:text-gray-700 transition"
            aria-label={`Clear ${label}`}
            tabIndex={-1}
          >
            <img src={crossIcon} alt="Clear" className="w-3.5 h-3.5" />
          </button>
        )}
      </div>
      {error && <p className="text-error mt-1">{error}</p>}
    </div>
  )
}
